import { Button, Grid, Paper, Typography, Modal as _Modal, styled } from '@mui/material'
import React from 'react'
import Movie from 'redux/models/movie'

const Modal = styled(_Modal)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'scroll',
}))

type VerificationModalProps = {
  item: Movie
  onClose: () => void
}

const VerificationModal = (props: VerificationModalProps) => {
  const { item, onClose } = props

  return (
    <Modal aria-labelledby="simple-modal-title" open onClose={onClose}>
      <Paper sx={{ p: 4 }}>
        <Grid
          container
          direction="column"
          spacing={3}
          sx={{
            alignItems: 'center',
          }}>
          <Grid>
            <Typography variant="h4" id="simple-modal-title">
              {item.word}
            </Typography>
          </Grid>
          <Grid>
            <video
              width={Math.min(window.screen.width * 0.7, 500)}
              height={Math.min(window.screen.height * 0.7, 500)}
              src={item.fileURL}
              controls
            />
          </Grid>
          <Grid>
            <a href={item.browserURL} target="blank">
              動画が見れない時はこちら
            </a>
          </Grid>
          <Grid>
            <Button variant="outlined" component="label" onClick={onClose}>
              閉じる
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Modal>
  )
}

export default VerificationModal
